import React from "react";
import { Row, Col } from "react-bootstrap";
import "./Nom035Person.css";

function Nom035Person({ firstName, lastName, profile }) {
  return (
    <Row className="nom035-person align-items-center">
      <Col className="nom035-person-header">
        <h5>
          {firstName} {lastName}
        </h5>
        <p>{profile}</p>
      </Col>
    </Row>
  );
}

export default Nom035Person;
